"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _BufferedEventEmitter2 = require("./helpers/BufferedEventEmitter");

var _BufferedEventEmitter3 = _interopRequireDefault(_BufferedEventEmitter2);

var _v = require("uuid/v1");

var _v2 = _interopRequireDefault(_v);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Channel = function (_BufferedEventEmitter) {
	_inherits(Channel, _BufferedEventEmitter);

	function Channel() {
		var token = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _v2.default)();

		_classCallCheck(this, Channel);

		var _this = _possibleConstructorReturn(this, (Channel.__proto__ || Object.getPrototypeOf(Channel)).call(this));

		_this.token = token;
		_this.connection = null;
		_this.dataChannel = null;
		return _this;
	}

	_createClass(Channel, [{
		key: "send",
		value: function send(data) {
			this._checkConnected();

			this.dataChannel.send(data);
		}
	}, {
		key: "disconnect",
		value: function disconnect() {
			var wasConnected = this.isConnected;
			if (this.dataChannel) this.dataChannel.close();
			if (this.connection) this.connection.close();

			this.connection = null;
			this.dataChannel = null;
			this.$waitAnswer = null;
			if (wasConnected) this.emit("disconnected");
		}
	}, {
		key: "connect",
		value: function connect(connection, dataChannel) {
			var _this2 = this;

			this._checkNotConnected();

			this.connection = connection;
			this.dataChannel = dataChannel;

			var run = function run(data) {
				return _this2.emit("data", data);
			};
			if (dataChannel.buffer) {
				dataChannel.buffer.forEach(run);
				delete dataChannel.buffer;
			}

			this.dataChannel.onmessage = function (e) {
				var data = e.data;
				if (!data) return;

				_this2.emit("data", data);
			};
			this.emit("connected");
		}
	}, {
		key: "_checkConnected",
		value: function _checkConnected() {
			if (!this.isConnected) throw new Error("Error: Not connected");
		}
	}, {
		key: "_checkNotConnected",
		value: function _checkNotConnected() {
			if (this.isConnected) throw new Error("Error: Already connected");
		}
	}, {
		key: "isConnected",
		get: function get() {
			return this.dataChannel !== null;
		}
	}]);

	return Channel;
}(_BufferedEventEmitter3.default);

exports.default = Channel;